import { render, staticRenderFns } from "./RButton.vue?vue&type=template&id=61c961be&"
import script from "./RButton.vue?vue&type=script&lang=js&"
export * from "./RButton.vue?vue&type=script&lang=js&"
import style0 from "./RButton.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports